import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: none;
	position: fixed;
	bottom: 15vh;
	right: 1vw;
	z-index: 100;
`;

export const Text = styled.h4`
	text-align: center;
	color: white;
	margin-bottom: 0!important;
`;

export const Icon = styled.img`
	display: block;
	margin: 10px auto;
	width: 60px;
	cursor: pointer;
`;

export const Anchor = styled.a`
`;
